import React, { useEffect, useState } from "react";
import { CardTypes } from "../../../../helpers/generalTypes";

const AdaptiveInformationCardRenderer = React.lazy(() =>
  import("./Adaptive-InformationCard-Renderer")
);
const AdaptiveSingleButtonCardRenderer = React.lazy(() =>
  import("./Adaptive-SingleButtonCard-Renderer")
);
const AdaptiveMultiButtonCardRenderer = React.lazy(() =>
  import("./Adaptive-MultiButtonCard-Renderer")
);
const AdaptiveRatingCardRenderer = React.lazy(() =>
  import("./Adaptive-RatingCard-Renderer")
);
const AdaptiveLinkCardRenderer = React.lazy(() =>
  import("./Adaptive-LinkCard-Renderer")
);
const AdaptiveImageOnlyCardRenderer = React.lazy(() =>
  import("./Adaptive-ImageOnlyCard-Renderer")
);
const AdaptiveDownloadCardRenderer = React.lazy(() =>
  import("./Adaptive-DownloadCard-Renderer")
);
const AdaptiveQrCodeScanCardRenderer = React.lazy(() =>
  import("./Adaptive-QrCodeScanCard-Renderer")
);
const AdaptiveTideSetupCodeButtonsCardRenderer = React.lazy(() =>
  import("./Adaptive-TideSetupCodeButtonsCard-Renderer")
);

const AdaptiveCardRenderer = (props) => {
  const [cardType, setCardType] = useState(undefined);
  useEffect(() => {
    if (cardType === undefined) {
      const cType = getCardType();
      setCardType(cType);
    }
  }, []);

  const getCardType = () => {
    let cardType = props.cardToRender?.props?.attachment?.content?.CardType;
    if (!cardType || cardType === CardTypes.SingleButtonCard) {
      const body = props.cardToRender?.props?.attachment?.content?.body;
      const actionCount =
        props.cardToRender?.props?.attachment?.content?.actions?.length ?? 0;
      let hasTextBlock = false,
        hasImage = false;
      for (let i = 0; i < body?.length; i++) {
        if (body[i].type === "TextBlock") {
          hasTextBlock = true;
        }
        if (body[i].type === "Image") {
          hasImage = true;
        }
      }
      if (actionCount == 0) {
        if (hasImage === true && hasTextBlock === false) {
          cardType = CardTypes.ImageOnlyCard;
        } else {
          cardType = CardTypes.InformationCard;
        }
      } else {
        if (actionCount === 1 && !hasTextBlock) {
          cardType = CardTypes.SingleButtonCard;
        } else {
          cardType = CardTypes.MultiButtonsCard;
        }
      }
    }
    return cardType;
  };

  const isUnknownCardType = (cType) => {
    let result = false;
    if (cType) {
      if (
        cType !== CardTypes.SingleButtonCard &&
        cType !== CardTypes.InformationCard &&
        cType !== CardTypes.MultiButtonsCard &&
        cType !== CardTypes.RatingCard &&
        cType !== CardTypes.LinkCard &&
        cType !== CardTypes.ImageOnlyCard &&
        cType !== CardTypes.DownloadCard &&
        cType !== CardTypes.QrCodeScanCard &&
        cType !== CardTypes.TideSetupCodeButtonsCard
      ) {
        console.log("Unknown Card Type", cType);
        result = true;
      }
    }
    return result;
  };

  return (
    <>
      {cardType && (
        <>
          {cardType === CardTypes.SingleButtonCard && (
            <React.Suspense fallback={<></>}>
              <AdaptiveSingleButtonCardRenderer
                cardToRender={props.cardToRender}
                activityId={props.activityId}
              />
            </React.Suspense>
          )}
          {cardType === CardTypes.InformationCard && (
            <React.Suspense fallback={<></>}>
              <AdaptiveInformationCardRenderer
                cardToRender={props.cardToRender}
              />
            </React.Suspense>
          )}
          {cardType === CardTypes.MultiButtonsCard && (
            <React.Suspense fallback={<></>}>
              <AdaptiveMultiButtonCardRenderer
                cardToRender={props.cardToRender}
                activityId={props.activityId}
              />
            </React.Suspense>
          )}
          {cardType === CardTypes.RatingCard && (
            <React.Suspense fallback={<></>}>
              <AdaptiveRatingCardRenderer
                cardToRender={props.cardToRender}
                activityId={props.activityId}
              />
            </React.Suspense>
          )}
          {cardType === CardTypes.LinkCard && (
            <React.Suspense fallback={<></>}>
              <AdaptiveLinkCardRenderer cardToRender={props.cardToRender} />
            </React.Suspense>
          )}
          {cardType === CardTypes.ImageOnlyCard && (
            <React.Suspense fallback={<></>}>
              <AdaptiveImageOnlyCardRenderer
                cardToRender={props.cardToRender}
              />
            </React.Suspense>
          )}
          {cardType === CardTypes.DownloadCard && (
            <React.Suspense fallback={<></>}>
              <AdaptiveDownloadCardRenderer cardToRender={props.cardToRender} />
            </React.Suspense>
          )}
          {cardType === CardTypes.QrCodeScanCard && (
            <React.Suspense fallback={<></>}>
              <AdaptiveQrCodeScanCardRenderer
                cardToRender={props.cardToRender}
              />
            </React.Suspense>
          )}
          {cardType === CardTypes.TideSetupCodeButtonsCard && (
            <React.Suspense fallback={<></>}>
              <AdaptiveTideSetupCodeButtonsCardRenderer
                cardToRender={props.cardToRender}
                activityId={props.activityId}
              />
            </React.Suspense>
          )}
          {isUnknownCardType(cardType) && <>{props.cardToRender}</>}
        </>
      )}
    </>
  );
};

export default AdaptiveCardRenderer;
